import React, { useEffect, useState, useMemo, useRef } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    InputGroup,
    Label,
    Input
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import ToastDialog from "components/Common/ToastDialog";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import TableContainerV1 from "components/Common/TableContainerV1";
import { getPendingOrderSalesReport, getOrderSalesReportSync } from "../../../helpers/UAM/report.helper"
import * as XLSX from 'xlsx';
import { formatDate, formatDateTime, formatNumberWithCommas, isPermission } from "common/utility";
import { getApiLogs } from "http/apiLogs/apiLogs";
import moment from 'moment';
import { AiOutlineSync } from 'react-icons/ai';

const PendingOrderSalesReport = () => {

    //meta title
    document.title = "Order Sales Report | DMS";

    const [pendingOrderSalesReport, setPendingOrderSalesReport] = useState([])

    const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [columnId, setColumnId] = useState("id");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const [filters, setFilters] = useState(null);
    const [filtersForSync, setFiltersForSync] = useState(null);
    const [sortingOptions, setSortingOptions] = useState({
        column: "",
        isAsc: false,
        optionalColumn: [],
    });
    const flatpickrRef = useRef(null);
    const [totalData, setTotalData] = useState('');
    const [lastSynced, setLastSynced] = useState(null);
    const user = JSON.parse(localStorage.getItem("user"));
    const [checkboxes, setCheckboxes] = useState({
        openQuantity: false,
    });
    const flatpickrRef2 = useRef(null);
    const [isSyncing, setIsSyncing] = useState(false);
    const [toastInfo, setToastInfo] = useState({ showToast: false })
    const [showFilter, setShowFilter] = useState(false);
    const [syncPermission, setSyncPermission] = useState(false);

    const columns = useMemo(
        () => [
            {
                Header: 'Plant',
                accessor: 'plant',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Customer No.',
                accessor: 'customerId',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Customer Name',
                accessor: 'customerName',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Sch Agreement No.',
                accessor: 'schAgreementNo',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Material No.',
                accessor: 'materialNo',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Material Description',
                accessor: 'materialDescription',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Delivery Date',
                accessor: 'deliveryDate',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatDate(cellProps.value) : "";
                }
            },
            {
                Header: 'Zone',
                accessor: 'zone',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'PO Number',
                accessor: 'poNumber',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Sch Quantity',
                accessor: 'schQuantity',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Delivered Quantity',
                accessor: 'deliveredQuantity',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Open Quantity',
                accessor: 'openQuantity',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Pending Order Value',
                accessor: 'pendingOrderValue',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatNumberWithCommas(cellProps.value) : "";
                }
            },
            {
                Header: 'Net Order Value',
                accessor: 'netOrderValue',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? <p style={{ width: '150px' }}>{formatNumberWithCommas(cellProps.value)}</p> : "";
                }
            },
            {
                Header: 'Schedule Item No',
                accessor: 'scheduleItemNo',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Sales Document Type',
                accessor: 'salesDocType',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Currency',
                accessor: 'currency',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Reason for Rejection',
                accessor: 'reasonForRejection',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Delivery Status',
                accessor: 'deliveryStatus',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Distribution Channel',
                accessor: 'distributionChannel',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Customer Material',
                accessor: 'customerMaterial',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Delivered Number',
                accessor: 'deliveredNumber',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Order Reason',
                accessor: 'orderReason',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Order Reason Text',
                accessor: 'orderReasonText',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
        ],
        []
    );

    useEffect(() => {
        fetchPendingOrderSalesReport({ page: 1, limit: pageSize, searchKey: '' })
        fetchLastSynced()
        checkPermission()
    }, [])

    const checkPermission = async () => {
        let isSyncPermission = await isPermission('sync', 'create_permission')
        setSyncPermission(isSyncPermission)
    }

    const fetchPendingOrderSalesReport = (data) => {
        getPendingOrderSalesReport(data)
            .then((response) => {
                if (response.status && response.code == 200) {
                    setPendingOrderSalesReport(response.data.data);
                    setTotalData(calculateZoneTotals(response.data.data))
                    const { totalItems, totalPages, currentPage } = response.data
                    setPagination({
                        pageIndex: currentPage,
                        pageCount: totalPages,
                        totalRecords: totalItems,
                    })
                } else {
                    setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                    setPendingOrderSalesReport([])
                }
            })
            .catch((err) => { console.log(err) })
    }

    const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus, filterType = filters, isOpenQuantity = checkboxes.openQuantity) => {
        setPageSize(pageSize);
        setCurrentPage(page)
        fetchPendingOrderSalesReport({ page, limit: pageSize, searchKey, columnName, sortingOrder, filterType, isOpenQuantity })
    };

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
        handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder);
    };

    const handleSearchFilter = (value, pageSize) => {
        const newValue = value !== undefined ? value : "";
        setSearchValue(newValue);
        handlePageChange(1, pageSize, newValue);
    };

    const handleClearSearch = () => {
        setSearchValue("");
        setFilters(null)
        flatpickrRef?.current?.flatpickr?.clear();
        setCheckboxes({
            openQuantity: false,
        });
        handlePageChange(1, pageSize, "", 'id', 'desc', null, false);
    };

    const handleDateFilter = () => {
        handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, filters)
    }

    const handleDateChange = (selectedDates) => {
        if (selectedDates.length === 2) {
            setFilters({
                startDate: selectedDates[0],
                endDate: selectedDates[1],
            })
        }
    };

    const downloadExcel = () => {
        let dataWithModifiedCol = pendingOrderSalesReport.map(report => {
            let newReport = {
                "Plant": report.plant,
                "Customer No.": report.customerId,
                "Customer Name": report.customerName,
                "Sch Agreement No.": report.schAgreementNo,
                "Material No.": report.materialNo,
                "Material Description": report.materialDescription,
                "Delivery Date": formatDate(report.deliveryDate),
                "Zone": report.zone,
                "PO Number": report.poNumber,
                "Sch Quantity": report.schQuantity,
                "Delivered Quantity": report.deliveredQuantity,
                "Open Quantity": report.openQuantity,
                "Pending Order Value": formatNumberWithCommas(report.pendingOrderValue),
                "Net Order Value": formatNumberWithCommas(report.netOrderValue),
                "Schedule Item No": report.scheduleItemNo,
                "Sales Document Type": report.salesDocType,
                "Currency": report.currency,
                "Reason for Rejection": report.reasonForRejection,
                "Delivery Status": report.deliveryStatus,
                "Distribution Channel": report.distributionChannel,
                "Customer Material": report.customerMaterial,
                "Delivered Number": report.deliveredNumber,
                "Order Reason": report.orderReason,
                "Order Reason Text": report.orderReasonText,
            };
            return newReport;
        });
        const totalSchQuantity = pendingOrderSalesReport.reduce((sum, report) => sum + report.schQuantity, 0);
        const totalDeliverQty = pendingOrderSalesReport.reduce((sum, report) => sum + report.deliveredQuantity, 0);
        const totalOpenQty = pendingOrderSalesReport.reduce((sum, report) => sum + report.openQuantity, 0);
        const totalPendingOrderValue = pendingOrderSalesReport.reduce((sum, report) => sum + report.pendingOrderValue, 0);
        const totalNetOrderValue = pendingOrderSalesReport.reduce((sum, report) => sum + report.netOrderValue, 0);

        dataWithModifiedCol.push({
            "Plant": "Total",
            "Sch Quantity": totalSchQuantity,
            "Delivered Quantity": totalDeliverQty,
            "Open Quantity": totalOpenQty,
            "Pending Order Value": formatNumberWithCommas(totalPendingOrderValue),
            "Net Order Value": formatNumberWithCommas(totalNetOrderValue),
        });
        // Create a new workbook
        const workbook = XLSX.utils.book_new();
        const sheetData = XLSX.utils.json_to_sheet(dataWithModifiedCol);
        // Add the sheet to the workbook
        XLSX.utils.book_append_sheet(workbook, sheetData, 'PendingOrderSalesReport');
        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, 'Order_Sales_Report.xlsx');
    };

    const toggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const handleDateChangeForSync = (selectedDates) => {
        if (selectedDates.length === 2) {
            setFiltersForSync({
                fromDate: selectedDates[0],
                toDate: selectedDates[1],
            })
        }
    };

    const handleClearFilters = () => {
        setFiltersForSync(null)
        setShowFilter(false)
        if (flatpickrRef2 && flatpickrRef2.current) {
            flatpickrRef2.current.flatpickr.clear();
        }
    };

    const handleSync = async () => {
        setIsSyncing(true);
        setShowFilter(false)
        if (!filtersForSync?.fromDate || !filtersForSync?.toDate) {
            setToastInfo({
                message: "Please select date range",
                showToast: true,
                role: "error",
            })
            setIsSyncing(false);
            return
        }
        try {
            let obj = {
                fromDate: moment(filtersForSync?.fromDate).format('YYYYMMDD'),
                toDate: moment(filtersForSync?.toDate).format('YYYYMMDD')
            }
            let res = await getOrderSalesReportSync(obj)
            if (res.status) {
                setToastInfo({
                    message: res.message,
                    showToast: true,
                    role: "success",
                })
                setIsSyncing(false);
                fetchLastSynced()
                fetchPendingOrderSalesReport({ page: 1, limit: pageSize, searchKey: '' })
            } else {
                setToastInfo({
                    message: "Something went wrong",
                    showToast: true,
                    role: "error",
                })
                setIsSyncing(false);
                fetchLastSynced()
            }

        } catch (err) {
            setToastInfo({
                message: "Something went wrong",
                showToast: true,
                role: "error",
            })
            setIsSyncing(false);
            fetchLastSynced()
        }
    }

    const buttonSection = (
        <div className="text-sm-end">
            <div className="d-lg-flex justify-content-end">
                {pendingOrderSalesReport.length > 0 && (<Button
                    type="button"
                    color="success"
                    className="btn-rounded mb-2 me-2"
                    onClick={downloadExcel}
                >
                    <i className="bx bx-archive-in me-1" />
                    {'Download'}
                </Button>)}
                {syncPermission && (<div className="text-md-end">
                    <Button
                        type="button"
                        color="success"
                        className="btn-rounded mb-2 me-2"
                        onClick={toggleFilter}
                    >
                        <AiOutlineSync size={15} className={isSyncing ? 'rotating' : ''} /> Sync Data
                    </Button>
                </div>)}
            </div>

            {showFilter && (
                <div className="filter-container2" style={{ minHeight: '50px' }}>
                    <div className="mb-1 d-flex justify-content-between align-items-center text-center">
                        <h5 style={{ margin: 0 }}>Filter</h5>
                        <button
                            type="button"
                            onClick={() => setShowFilter(false)}
                            style={{
                                border: 'none',
                                background: 'transparent',
                                fontSize: '1.2rem',
                                cursor: 'pointer',
                            }}
                        >
                            ×
                        </button>
                    </div>
                    <div className="d-flex align-items-center justify-content-start">
                        <InputGroup style={{ minWidth: '250px' }}>
                            <Flatpickr
                                ref={flatpickrRef2}
                                className="form-control"
                                placeholder="Start Date - End Date"
                                options={{
                                    mode: 'range',
                                    dateFormat: 'd-m-Y',
                                }}
                                value={filtersForSync?.fromDate && filtersForSync?.toDate ? [filtersForSync?.fromDate, filtersForSync?.toDate] : []}
                                onChange={handleDateChangeForSync}
                            />
                            <Button variant="primary"
                                onClick={handleSync}
                                style={{ backgroundColor: "#344fa0", border: "none" }}>
                                Go
                            </Button>
                        </InputGroup>
                    </div>
                    <div className="d-flex flex-row justify-content-end gap-2 mt-3">
                        <Button
                            type="button"
                            color="light"
                            className="btn-rounded"
                            onClick={handleClearFilters}
                        >
                            Clear
                        </Button>
                    </div>
                </div>
            )}

            {lastSynced && <p className="d-flex justify-content-end ">Last Synced: {lastSynced}</p>}
        </div>
    );

    const calculateZoneTotals = (data) => {
        let deliveredQuantity = 0
        let openQuantity = 0
        let pendingOrderValue = 0
        let netOrderValue = 0
        let schQuantity = 0
        data.forEach(item => {
            deliveredQuantity += item.deliveredQuantity || 0
            openQuantity += item.openQuantity || 0
            pendingOrderValue += item.pendingOrderValue || 0
            netOrderValue += item.netOrderValue || 0
            schQuantity += item.schQuantity || 0
        });
        return (<tr>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{'Total'}</td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}></td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{schQuantity}</td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{deliveredQuantity}</td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{openQuantity}</td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{formatNumberWithCommas(pendingOrderValue)}</td>
            <td className="table-row-odd font-size-14" style={{ fontWeight: '600' }}>{formatNumberWithCommas(netOrderValue)}</td>
        </tr>)
    };

    const fetchLastSynced = async () => {
        try {
            let res = await getApiLogs({ masterName: 'pending_sale_report' })
            if (res.status) {
                setLastSynced(formatDateTime(res.data.initialDateTime))
            }
        } catch (err) {
            console.error(err)
        }
    }

    const handleRadioChange = (e) => {
        const { value } = e.target;
        setCheckboxes({
            openQuantity: value === 'openQuantity',
        });
        handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, filters, true)
    };

    const customeFilterSection = (
        <div className="d-md-flex align-items-center justify-content-start gap-3">
            <div className="d-flex align-items-center justify-content-start">
                <InputGroup style={{ minWidth: '250px' }}>
                    <Flatpickr
                        ref={flatpickrRef}
                        className="form-control"
                        placeholder="Start Date - End Date"
                        options={{
                            mode: 'range',
                            dateFormat: 'd-m-Y',
                        }}
                        value={filters?.startDate && filters?.endDate ? [filters?.startDate, filters?.endDate] : []}
                        onChange={handleDateChange}
                    />
                    <Button variant="primary"
                        onClick={handleDateFilter}
                        style={{ backgroundColor: "#344fa0", border: "none" }}>
                        Go

                    </Button>
                </InputGroup>
            </div>
            <div className="d-flex align-items-center">
                <div className="form-check">
                    <Input
                        type="radio"
                        className="form-check-input"
                        id="openQuantity"
                        name="item"
                        value="openQuantity"
                        checked={checkboxes.openQuantity}
                        onChange={handleRadioChange}
                    />
                    <Label className="form-check-label" htmlFor="openQuantity">
                        Open Quantity
                    </Label>
                </div>
            </div>
        </div>
    )
      
    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs title="Reports" breadcrumbItem="Order Sales Report" />
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <TableContainerV1
                                    columns={columns}
                                    data={pendingOrderSalesReport}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    searchHelperText="Search by Customer Name, Material, Material Description, Plant"
                                    handleSearchFilter={handleSearchFilter}
                                    customFilterSection={customeFilterSection}
                                    customSection={buttonSection}
                                    sortOptions={sortingOptions}
                                    handleClearSearch={handleClearSearch}
                                    handleSortColumn={handleSortColumn}
                                    className="custom-header-css"
                                    isTotal={true}
                                    TotalData={totalData}
                                />
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </Container>
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </div>
    );
};

export default PendingOrderSalesReport;
